import React, { useState, useEffect, useRef, Fragment } from "react";
import moment from "moment";
import Swal from "sweetalert2";
import axios from "axios";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faFileExcel, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import i18n from "../../../../i18n";
import cookieManager from "../../../../utils/cookieManager";
import Select2 from "../../../utilities/Form/Select2";
import { formatNumber } from "../../../utilities/Class/FormatNumber";

const CustomerPerformanceSales = (props) => {
  const {
    isProcessing,
    helperCustomerPerformance,
    dataList,
    isError,
    errorMessage,
    helperList,
    setDataSales,
  } = props;

  const [fillList, setFillList] = useState(0);
  const [branchList, setBranchList] = useState([]);
  const [branchCurrent, setBranchCurrent] = useState(null);
  const [branchText] = useState(i18n.t("Select Branch"));
  const [typeCustomerList, setTypeCustomerList] = useState([]);
  const [typeCustomerCurrent, setTypeCustomerCurrent] = useState(null);
  const [typeCustomerText] = useState(i18n.t("Select Type Customer"));
  const [customerList, setCustomerList] = useState([]);
  const [customerCurrent, setCustomerCurrent] = useState(null);
  const [customerText] = useState(i18n.t("All"));
  const [periodList, setPeriodList] = useState([]);
  const [periodStartCurrent, setPeriodStartCurrent] = useState(null);
  const [periodEndCurrent, setPeriodEndCurrent] = useState(null);
  const [periodText] = useState(i18n.t("Select Period"));
  const [periodEndList, setPeriodEndList] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [typeChart, setTypeChart] = useState(2);
  const [loadingCustomer, setLoadingCustomer] = useState(false);
  const [page, setPage] = useState(1);
  const [headeTable, setHeadeTable] = useState(false);
  console.log('STATE', { setTypeCustomerCurrent, typeCustomerCurrent });
  console.log('PROPS', props);
  const formData = useRef();

  useEffect(() => {
    if (helperCustomerPerformance != null && fillList === 0) {
      setBranchList(helperCustomerPerformance.branch);
      setTypeCustomerList(helperCustomerPerformance.tipe);
      setPeriodList(helperCustomerPerformance.workCalendar);
      setFillList(1);
    }
  }, [helperCustomerPerformance, fillList]);

  const renderError = (name) => {
    let value = "";
    if (isError) {
      if (errorMessage[name] !== undefined) {
        value = errorMessage[name][0];
      }
      Swal.close();
    }
    return value;
  };

  const setData = () => {
    const startDateParam =
      typeChart === 1
        ? moment(startDate).format("YYYY-MM-DD")
        : typeChart === 2
        ? periodStartCurrent?.value || ""
        : null;
    const endDateParam =
      typeChart === 1
        ? moment(endDate).format("YYYY-MM-DD")
        : typeChart === 2
        ? periodEndCurrent?.value || ""
        : null;
    const idBranch = branchCurrent?.value || "";
    const idCustomer = customerCurrent?.value || "";
    const idTypeCustomer = typeCustomerCurrent?.value || "";

    let params = {
      startDate: startDateParam,
      endDate: endDateParam,
      idBranch,
      idCustomer,
      idTypeCustomer,
      type: typeChart,
    };
    setDataSales(params);
  };

  const validateForm = () => {
    // contoh dummy, sesuaikan sama validasi kamu
    if (!branchCurrent) {
      return { status: false, message: "Branch harus dipilih", form: {} };
    } else if (!typeCustomerCurrent){
      return { status: false, message: "Tipe Pelanggan harus dipilih", form: {} };
    }
    return { status: true, form: { someField: "value" } };
  };

  const alertHandler = (title, message, type = "info") => {
    Swal.fire({
      title,
      text: message,
      icon: type,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "OK",
    });
  };

  // const renderError = (field) => {
  //   return `Terjadi error di ${field}`;
  // };

  const convertExcel = async (e) => {
    e.preventDefault();
    const valid = validateForm();

    if (!valid.status) {
      alertHandler("Validate Error", valid.message, "warning");
      return;
    }

    // const idBranch = branchCurrent ? branchCurrent.value : "";
    const branch = branchCurrent ? branchCurrent.label : "";
    const startDateParam =
      typeChart === 1
        ? moment(startDate).format("YYYY-MM-DD")
        : typeChart === 2
        ? periodStartCurrent?.value || ""
        : null;
    const endDateParam =
      typeChart === 1
        ? moment(endDate).format("YYYY-MM-DD")
        : typeChart === 2
        ? periodEndCurrent?.value || ""
        : null;
    const idBranch = branchCurrent?.value || "";
    const idCustomer = customerCurrent?.value || "";
    const idTypeCustomer = typeCustomerCurrent?.value || "";

    const params = {
      // ...valid.form,
      idBranch,
      startDate: startDateParam,
      endDate: endDateParam,
      idBranch,
      idCustomer,
      idTypeCustomer,
      type: typeChart,
    };

    try {
      // setLoading(true);
      Swal.fire({
        title: "Sedang memproses...",
        html: "Mohon tunggu hingga file siap diunduh",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });
      const token = cookieManager.getUserToken();
      const response = await axios({
        headers: { Authorization: `Bearer ${token}` },
        url: process.env.REST_URL + "chart/customer-performance-sales-excel",
        method: "POST",
        data: params,
        responseType: "blob",
      });
      console.log(response)
      if (response && response.status === 200 && response.data) {
         Swal.close();
          Swal.fire({
            icon: "success",
            title: "Convert Excel",
            text: "Download berhasil",
            timer: 1500,
            showConfirmButton: false,
          });
        const blobUrl = window.URL.createObjectURL(response.data);

        const link = document.createElement("a");
        link.style.display = "none";
        link.href = blobUrl;
        link.setAttribute(
          "download",
          `${branch} - Laporan Performa Pelanggan.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Convert Excel",
        text:
          error?.response?.data?.message ||
          error.message ||
          "Download gagal, coba lagi",
        confirmButtonText: "OK",
      });
    } finally {
      // setLoading(false);
    }
  };

  const changeData = ({ keyFill, type = null, value = null, callback = () => {} }) => {
    let url = null;
    let params = {};
    const token = cookieManager.getUserToken();

    switch (type) {
      case "getCustomer":
        url = process.env.REST_URL + "helper/get-list-customer";
        if (branchCurrent == null) type = null;
        console.log('msuk')
        params = {
          branch: branchCurrent?.value || null,
          tipe: value || typeCustomerCurrent?.value || null,
        };
        console.log('params',params)
        break;
      default:
        break;
    }

    if (type != null) {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        url,
        responseType: "json",
        params,
      })
        .then((response) => {
          if (response?.status === 200 && response.data) {
            callback(response.data.result);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  // const renderList = () => {
  //   if (dataList?.list?.length > 0) {
  //     return dataList.list.map((row, i) => (
  //       <tr className="border" key={i}>
  //         <td className="search-td" style={{minWidth:"180px"}} >{row.name_customer}</td>
  //         <td className="search-td">{row.district}</td>
  //         {/* <td className="search-td">{row.week}</td>
  //         <td className="search-td">{row.month}</td> */}
  //         {dataList.range.map((week) =>
  //               items.map((item) => {
  //                 const value =
  //                   salesMap[cust.idCustomer]?.[week]?.[item.id_item] || "";
  //                 return <td key={`${cust.idCustomer}-${week}-${item.id_item}`}>{value}</td>;
  //               })
  //             )}
  //         {/* {row.value?.map((val, idx) => {
  //           const found = val.detail.find(
  //               u => parseInt(u.id) === parseInt(header.idUnit)
  //           );
  //           <Fragment key={idx}>
  //             <td className="search-td" style={{ textAlign: "right" }}>
  //               {val.volume_format}
  //             </td>
  //           </Fragment>
  //         })} */}
  //       </tr>
  //     ));
  //   }
  //   return null;
  // };


const renderList = () => {
  const customers = dataList.list || [];
  const items = dataList.item || [];
  const range = dataList.range || [];
  
  return customers.map((cust, custIndex) => (
    <tr key={custIndex}>
      <td className="search-td" style={{minWidth:'180px'}}>{cust.name_customer}</td>
      <td className="search-td">{cust.district}</td>

      {range.map((week, wIndex) =>
        items.map((item, iIndex) => {
          const weekData = (cust.value || []).find((v) => v.week === week);

          const found = weekData?.selling?.find(
            (s) => s.idItem === item.id_item
          );

          const value = found ? formatNumber(found.sumQty) : "";

          return (
            <td
              key={`${custIndex}-${wIndex}-${iIndex}`}
              className="search-td"
              style={{ textAlign: "center" }}
            >
              {(value)}
            </td>
          );
        })
      )}
    </tr>
  ));
};

  const renderTable = () => {
    const customers = dataList.list || [];
    const item = dataList.item || [];
    const range = dataList.range || [];
    if (customers?.length > 0 && !isError) {
      return (
        <div>
          <div id="html-dist"></div>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              textAlign: "center",
              marginTop: "5px",
            }}
          >
            {i18n.t("Customer Performance")}
          </div>
          <div className="row">
            <div className="search-table-outter">
              <br />
              <table
                className="search-table"
                style={{ borderBottom: "1px solid #eff2f5", fontSize:'14px' }}
              >
                <thead className="search-thead">
                  <tr>
                    <th rowSpan={2} className="search-th" style={{minWidth:"180px"}}>
                      {i18n.t("Name Customer")}
                    </th>
                    <th rowSpan={2} className="search-th">
                      {i18n.t("District")}
                    </th>
                    {/* <th rowSpan={2} className="search-th">
                      {i18n.t("Week")}
                    </th>
                    <th rowSpan={2} className="search-th">
                      {i18n.t("Month")}
                    </th> */}
                    {range.map((col, i) => (
                      <th key={i} colSpan={item.length} className="search-th">
                        {i18n.t("Week ") + col}
                      </th>
                    ))}
                  </tr>
                  <tr>
                    {range.map((_, rangeIndex) => (
                      <Fragment key={rangeIndex}>
                        {item.map((row, itemIndex) => (
                          <th key={`${rangeIndex}-${itemIndex}`} className="search-th">
                            {row.name}
                          </th>
                        ))}
                      </Fragment>
                    ))}
                  </tr>
                  {/* <tr>
                    {item.map((_, i) => (
                      <Fragment key={i}>
                        <th className="search-th">{"items"}</th>
                      </Fragment>
                    ))}
                  </tr> */}
                </thead>
                <tbody className="search-body">{renderList()}</tbody>
              </table>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "5px",
        }}
      >
        {i18n.t("DATA NOT FOUND")}
      </div>
    );
  };

  //Render Header
  return (
    <Fragment>
      <div className="row">
        {typeChart === 2 && (
          <Fragment>
            <div className="col-sm-2 mt-3">
              <Select2
                name={"Period"}
                isClearable
                onChange={(e) => {
                  setPeriodEndList([]);
                  setPeriodEndCurrent("");
                  setPeriodStartCurrent(e);
                  if (e) {
                    const index = periodList.findIndex(
                      (item) => item.value === e.value
                    );
                    // const newList = periodList.slice(index, index + 5);
                    // setPeriodEndList(newList);
                  }
                }}
                options={periodList}
                value={periodStartCurrent}
                placeholder={periodText}
                title={i18n.t("Week Period")}
              />
            </div>
            <div style={{ width: "35px" }} className="col-sm-1 mt-11">
              {i18n.t("To")}
            </div>
            <div className="col-sm-2 mt-6">
              <Select2
                title={""}
                name={"periodCurrent"}
                isClearable
                onChange={(e) => setPeriodEndCurrent(e)}
                options={periodList}
                // options={periodEndList}
                value={periodEndCurrent}
                placeholder={periodText}
              />
            </div>
          </Fragment>
        )}

        <div className="col-sm-2 mt-3">
          <Select2
            isClearable
            onChange={(e) => {
              setBranchCurrent(e);
              if (e == null) {
                setCustomerList([]);
                setCustomerCurrent("");
              } else {
                setLoadingCustomer(true);
                
              }
            }}
            name={"idBranch"}
            options={branchList}
            value={branchCurrent}
            placeholder={branchText}
            title={i18n.t("Branch")}
          />
          <div className="fv-plugins-message-container invalid-feedback">
            {renderError("idBranch")}
          </div>
        </div>

        <div className="col-sm-2 mt-3">
          <Select2
            name={"typeCustomer"}
            isClearable
            onChange={(e) => {
              setTypeCustomerCurrent(e);
              if (e == null) {
                setCustomerList([]);
                setCustomerCurrent("");
              } else {
                setLoadingCustomer(true);
                changeData({
                  keyFill: "customerList",
                  type: "getCustomer",
                  value: e.value,
                  callback: (data) => {
                    setCustomerList(data);
                    setLoadingCustomer(false);
                  },
                });
              }
            }}
            options={typeCustomerList}
            value={typeCustomerCurrent}
            placeholder={typeCustomerText}
            title={i18n.t("Type Customer")}
          />
          <div className="fv-plugins-message-container invalid-feedback">
            {renderError("idTypeCustomer")}
          </div>
        </div>

        <div className="col-md-2 mt-3">
          <Select2
            name={"customerId"}
            isClearable
            onChange={(e) => setCustomerCurrent(e)}
            options={customerList}
            value={customerCurrent}
            placeholder={customerText}
            isLoading={loadingCustomer}
            title={i18n.t("Customer")}
          />
        </div>
      </div>

      <div className="row ml-5">
        <div className="col-md-9 mt-3 mb-3">
          <Button
            onClick={() => {
              setPage(1);
              setData();
              setHeadeTable(true);
            }}
            variant="success"
            className="btn btn-md btn btn-success m-1"
          >
            <FontAwesomeIcon icon={faEye} /> {i18n.t("  Generate")}
          </Button>
          <button className="btn btn-secondary dropdown-toggle m-1" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {i18n.t("Convert")}
            </button>
            <div className="dropdown-menu dropdown-menu-area" aria-labelledby="dropdownMenuButton">
                {/* <a className="dropdown-item" onClick={()=>this.convertPdf()}><FontAwesomeIcon icon={faFilePdf}></FontAwesomeIcon>  {i18n.t("PDF")}</a>  */}
                <a className="dropdown-item " href="#" onClick={convertExcel}><FontAwesomeIcon icon={faFileExcel}></FontAwesomeIcon>  {i18n.t("Excel")} </a>
          
            </div>
        </div>
      </div>

      {headeTable && (
        <div className={isProcessing ? "table-loading" : ""}>
          {!isProcessing ? (
            <Fragment>{renderTable()}</Fragment>
          ) : (
            <div className="table-loading-message">
              <div className="spinner-border text-primary text-center ms-3 clearfix"></div>
              <div className="text-center">{i18n.t("Loading")}</div>
            </div>
          )}
        </div>
      )}
    </Fragment>
  );
};

export default CustomerPerformanceSales;
